import { http, defaultConfig, getUniversityUrl } from './http';

export const fetch = () => {
  const baseURL = getUniversityUrl();
  return http.get('/rest/selfs', defaultConfig(baseURL));
};
